import React from 'react';
import { FaHome, FaHeart, FaPhoneAlt, FaShoppingCart, FaUser } from 'react-icons/fa';
import './BottomNav.css';
import { Link, useLocation } from 'react-router-dom';

const BottomNav = () => {
    const location = useLocation();

    return (
        <div className="bottom-nav">
            <Link to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                <FaHome />
                <span>Home</span>
            </Link>
            <Link to="/wishlist" className={`nav-item ${location.pathname === '/wishlist' ? 'active' : ''}`}>
                <FaHeart />
                <span>Wishlist</span>
            </Link>
            <Link to="/contact-us" className={`nav-item ${location.pathname === '/contact-us' ? 'active' : ''}`}>
                <FaPhoneAlt />
                <span>Contact</span>
            </Link>
            <Link to="/cart" className="nav-item">
                <FaShoppingCart />
                <span>Cart</span>
            </Link>
            <div className="nav-item">
                <FaUser />
                <span>Account</span>
            </div>
        </div>
    );
};

export default BottomNav;
